// extracted by mini-css-extract-plugin
export default {"loadingContainer":"Loading_loadingContainer__zOHyK","spinner":"Loading_spinner__qWscU","spin":"Loading_spin__sIASD"};